import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { IOsdDisposition } from "../models/osd";
import { throwApiError } from "./apiError";

/**
 * GET API call using Axios
 * @returns - GET SEND DESPOSITION DATA AND RETURN IOsdDisposition type
 */

export const getDispositionData = async (osdNumber: string, apiHeaders: Record<string, string>): Promise<IOsdDisposition> => {
  try {
    let headers = {
      "Content-Type": "application/json",
      "OSD-Action-Type": "get",
      "OSD-Exception-Number": osdNumber,
      ...apiHeaders,
    };
    const response = await axios.get(`${getUrl(ApiType.SEND_DISPOSITION_DATA).replace(":osdNumber", osdNumber)}`, { headers });
    return response.data;
  } catch (error: any) {
    return throwApiError(error, ErrorMessages.sendDispositionData, { badRequestOrder: "errorsFirst" });
  }
};
